"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateMapComponent = void 0;
const react_1 = __importDefault(require("react"));
const FieldRender_1 = __importDefault(require("../wrappers/FieldRender"));
const ValidationOptimizer_1 = __importDefault(require("../wrappers/ValidationOptimizer"));
/**
 * This is a helper function to create the most typical type of Page component, one that supports conditional display,
 * repeatable fields, field level validation, and read only support
 * @param controlProvider The map of controls from which to grab the consumer's implementation
 */
const generateMapComponent = (controlProvider) => {
    const NewComponent = (props) => {
        const Control = controlProvider['aggregateMap'];
        const { controlDefinition, controlPath, value, values, displayMap, forceOneLine, hidden } = props;
        if (Control) {
            return (react_1.default.createElement(ValidationOptimizer_1.default, { key: controlPath, controlDefinition: controlDefinition, displayMap: displayMap, render: validationFn => {
                    return (react_1.default.createElement(FieldRender_1.default, { controlPath: controlPath, controlDefinition: controlDefinition, validationFn: validationFn, value: value, values: values, defaultDateTimeFormat: props.defaultDateTimeFormat, render: props => {
                            var _a;
                            return ((_a = props.displayOptions) === null || _a === void 0 ? void 0 : _a.isVisible) !== false && !hidden ? (values && (react_1.default.createElement(Control, Object.assign({}, Object.assign(Object.assign({}, props), { controlDefinition: Object.assign(Object.assign({}, controlDefinition), { oneLine: forceOneLine || controlDefinition.oneLine, truncate: forceOneLine, label: props.label || controlDefinition.label }) }))))) : react_1.default.createElement(react_1.default.Fragment, null);
                        } }));
                } }));
        }
        else {
            return null;
        }
    };
    return NewComponent;
};
exports.generateMapComponent = generateMapComponent;
